import { Alert, useTenant } from "@dehub/theme";
import { InfoIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import type { BusinessType } from "../types";

type Props = Readonly<{ type: BusinessType }>;

/** Calm info note (theme Alert) replacing the red "Анхаар!" alert; no close button. */
export function BusinessNotice({ type }: Props) {
  const { t } = useTranslation("business");
  const tenant = useTenant();

  return (
    <Alert color="gray" icon={<InfoIcon size={18} aria-hidden="true" />} role="note">
      {t(`notice.${type}`, { tenant: tenant?.name || "DeHUB" })}
    </Alert>
  );
}
